export { default } from "bullitttime-embercomponents/components/bi-icon";
